import React, { useState } from 'react'
import background from '../Assets/Background.png'
import { BsStars } from "react-icons/bs";
import axios from 'axios';
import check from '../Assets/checked.png';
import { Link } from 'react-router-dom';


function CheckInpage() {
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [businessName, setBusinessName] = useState('')
  const [businessAddress, setbusinessAddress] = useState('')
  const [earlyAccess, setEarlyAccess] = useState(false)
  const [thankyouPage, setThankyouPage] = useState(false);

const handleSubmit = async(e) =>{
  e.preventDefault()
  // console.log(name,number,businessName,businessAddress,earlyAccess);
  const formData ={
    name:name,
    mobile:number,
    business_name: businessName,
    business_address: businessAddress,
    earlyAccess:earlyAccess,
  }
  const response = await axios.post('http://localhost:8000/api/waitlist/create',formData)
  if(response.data.status === 200){
    setName('')
    setNumber('');
    setBusinessName('')
    setbusinessAddress('')
    setEarlyAccess(false)
  }
  console.log('response',response);

  // alert('Thank you for submitting the form, We will get back to you ')
  setThankyouPage(true);
}

  return (
    <div style={{ backgroundImage: `url(${background})`}} className="flex flex-col justify-center gap-5 items-center w-screen h-screen bg-cover">  
      <Link to={'/'}>
      <div className="bold text-[20px]">ELYZIAN</div>
      </Link>

      <div className='flex items-center justify-center sm:text-xl p-2 text-base bold gap-3 text-[#333333]'>

      Fill the form to join waitlist
      <BsStars className="text-yellow-300" />
      </div>
      {!thankyouPage ? (
      <div className='sm:w-[85%] md:w-[40%] w-[85%] p-8 border-[3px]  rounded-2xl shadow-xl bg-white'>
      <form>
  <div class="mb-6">
    <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your name</label>
    <input
    value={name}
    onChange={(e) => setName(e.target.value)}
    type="text" id="email" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg outline-none focus:ring-blue-200 focus:ring-4 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Your name" required />
  </div>
  <div class="mb-6">
    <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your mobile number</label>
    <input type="text" id="text" 
    value={number}
    onChange={(e) => setNumber(e.target.value)}
    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg outline-none focus:ring-blue-200 focus:ring-4  focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder='Your mobile number' required />
  </div>
  <div class="mb-6">
    <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your Business name</label>
    <input type="text" id="text" 
    value={businessName}
    onChange={(e) => setBusinessName(e.target.value)}
    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg outline-none focus:ring-blue-200 focus:ring-4 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Your Business name" required />
  </div>
  <div class="mb-6">
    <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your Business address</label>
    <input type="text" id="text" 
    value={businessAddress}
    onChange={(e) => setbusinessAddress(e.target.value)}
    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg outline-none focus:ring-blue-200 focus:ring-4 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Your Business name" required />
  </div>
  <div class="flex items-start mb-6">
    <div class="flex items-center h-5">
      <input key={earlyAccess} id="remember" type="checkbox" 
      value={earlyAccess}
      onChange={(e) => setEarlyAccess(e.target.checked)}
      class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800" required />
    </div>
    <label for="remember" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Enroll for early-access</label>
  </div>
  <button onClick={handleSubmit} type="submit" 
  class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
    Start your survey</button>
</form>
</div>) : (<div className='flex sm:w-[85%] p-8 md:w-[40%] w-[85%] h-96 gap-7 bg-white rounded-2xl border-[3px] shadow-xl flex-col items-center justify-center'><img className='w-20' src={check} alt="" /><span className='bold text-lg text-center'>Thank you for submitting the form. We'll contact you shortly.</span></div>)}
      
    </div>
  )
}

export default CheckInpage
